module.exports = __webpack_public_path__ + "static/media/error-500.8ca260ea.svg";